<template>
  <div class="item" :id="'prod-' + index">
    <!-- Tutorial -->
    <Tooltip
      :tWidth="200"
      :tBottom="-72"
      :avatar="true"
      :hand="true"
      v-if="index === 0 && $store.state.tutStep === 0"
      >Press here to earn money</Tooltip
    >

    <Tooltip
      :tWidth="320"
      :tBottom="-72"
      :avatar="true"
      :hand="true"
      v-if="index === 0 && $store.state.tutStep === 2"
      >Great Job 👍 <br />Now you will get more money!</Tooltip
    >

    <!-- Icon -->
    <div
      class="itemHead shadow100 center"
      :class="{ active: isActive }"
      @click="earn"
    >
      <img :src="itemIcon" alt="item.name" />

      <div v-if="level" class="lvl">
        <span class="small2 black">{{ level }}</span>
      </div>
    </div>

    <!-- Progress and bytton -->
    <div class="itemBody">
      <span class="heading2 black" v-if="!on"> {{ name }}</span>

      <!-- BUY -->
      <ButtonChip
        @bought="inProgress = false"
        :med="medicine"
        :price="upgradePrice"
        :item="name"
        :index="index"
        action="buy"
        v-if="!on"
        >Buy</ButtonChip
      >
      <!-- UPGRADE -->
      <ButtonChip
        :price="upgradePrice"
        :item="name"
        :index="index"
        :med="medicine"
        action="upgrade"
        v-if="on"
        >Upgrade</ButtonChip
      >
      <ProgressBar
        v-if="on"
        :time="timeX"
        :revenue="revenue"
        :progress="inProgress"
        :med="medicine"
        @finish="inProgress = false"
      />
    </div>
  </div>
</template>

<script>
import ButtonChip from "@/components/ButtonChip.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import Tooltip from "@/components/Tooltip.vue";

const tap = new Audio(require("@/assets/mp3/tap.mp3"));

export default {
  name: "Prod Item",
  components: { ButtonChip, ProgressBar, Tooltip },
  props: {
    name: String,
    index: Number,
    level: Number,
    price: Number,
    time: Number,
    icon: String,
    on: Boolean,
    medicine: Boolean,
  },

  data() {
    return { inProgress: false };
  },

  mounted: function() {},

  computed: {
    itemIcon: function() {
      return require("@/" + this.icon);
    },

    timeX: function() {
      return this.time / this.timeMulti;
    },

    timeMulti: function() {
      return this.$store.state.timeMulti;
    },

    upgradePrice: function() {
      if (this.price > 100000) {
        return Math.round(this.price * this.level ** 1.05);
      } else if (this.name === "Bio-Robot Bee Hive" && this.price > 1000000) {
        return Math.round(this.price - this.price * 0.2);
      } else {
        return Math.round(this.price * this.level ** 1.15);
      }
    },

    revenue: function() {
      return this.price * this.level;
    },

    isActive: function() {
      if (!this.inProgress && this.on) {
        if (this.medicine) {
          return true;
        } else {
          if (this.$store.state.lockdown) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    },
  },

  methods: {
    earn: function() {
      this.inProgress = true;
      if (this.$store.state.tutStep === 0) {
        this.track("1st Step", "Onboarding");
        this.$store.commit("plusTutStep");
      }

      if (this.$store.state.tutStep === 2) {
        this.track("3rd Step", "Onboarding");
        this.$store.commit("plusTutStep");
      }

      if (this.$store.state.music) {
        tap.play();
      }
    },
    start: function() {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.item {
  display: grid;
  grid-template-columns: 66px 1fr;
  gap: 0 32px;
  margin: 0 16px;
  position: relative;

  .itemHead {
    position: relative;
    background: $gray200;
    border-radius: 12px;
    border: 4px solid #fff;
    max-height: 78px;
    transition: 0.25s;
    pointer-events: none;

    .lvl {
      width: 100%;
      background: #fff;
      text-align: center;

      span {
        padding: 4px 0;
      }
    }
  }

  .active {
    background: $blue;
    pointer-events: auto;
  }

  .itemBody {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    span {
      margin-bottom: 8px;
    }
  }
}
</style>
